define.alias("shared/components/shared/profile-categorization/selected-types", "media/components/shared/profile-categorization/selected-types");